import React from "react";
import { getTargetDate } from "../utils/getTargetDate";
import { useCountdown } from "./useCountdown";
import { useTranslation } from "react-i18next";

const CountdownBanner = () => {
  const targetDate = getTargetDate();
  const { days, hours, minutes, seconds } = useCountdown(targetDate);
  const { t } = useTranslation();

  return (
    <div
      style={{
        width: "100%",
        background:
          "linear-gradient(90deg, #0f4d28 0%, #1b7a3d 50%, #0f4d28 100%)",
        color: "#fff",
        padding: "0.55rem 1rem",
        textAlign: "center",
        fontFamily: "Tajawal, Poppins, sans-serif",
        fontSize: "clamp(0.85rem, 1.6vw, 1.05rem)",
        fontWeight: 500,
        letterSpacing: "0.01em",
      }}
    >
      <p style={{ margin: 0, lineHeight: 1.35 }}>
        {t("count_nextOrderCounterA")}
        {days} {t("count_nextOrderCounterB")}{" "}
        <span style={{ fontVariantNumeric: "tabular-nums", fontWeight: 700 }}>
          {hours.toString().padStart(2, "0")}:
          {minutes.toString().padStart(2, "0")}:
          {seconds.toString().padStart(2, "0")}
        </span>{" "}
        {t("count_nextOrderCounterC")}
      </p>
    </div>
  );
};

export default CountdownBanner;
